// Shared swatch-palette rules for EVERY colour picker (Gordon law 2026-09-16:
// "every colour picker has a White swatch"). Each preset palette a picker
// renders is built through withWhiteSwatch, so white is always the FIRST
// swatch and can never be dropped from one picker while another keeps it.
// Measured before this change on web-dev (main.2462108d.js): Gallery Theme
// Accent/Background/Wallpaper>Color and LinkVault Background had 0 white
// swatches (C:\iYuga\qa-notes\vy\themes-gordon-items-measure-0916\READY.md).

export const WHITE_SWATCH = "#FFFFFF";

const WHITE_VALUES = new Set(["#fff", "#ffffff", "white"]);

// True for any spelling of pure white.
export const isWhiteSwatch = (color) =>
  typeof color === "string" && WHITE_VALUES.has(color.trim().toLowerCase());

// Returns the palette with WHITE_SWATCH first and no second white entry.
// Every other colour keeps its original order.
export const withWhiteSwatch = (palette) => [
  WHITE_SWATCH,
  ...palette.filter((color) => !isWhiteSwatch(color)),
];

// A white swatch sits on white pickers, so it gets a 1px neutral ring. The
// colour is the 1px neutral line token the theme panels already use for
// their tile borders (GalleryTheme/constants.js T.line "#e1e1e1").
export const WHITE_SWATCH_RING = "inset 0 0 0 1px #E1E1E1";

// The shared swatch drop shadow every ColorSwatch uses.
export const SWATCH_SHADOW = "rgba(0, 0, 0, 0.16) 0px 1px 4px";

// box-shadow for a swatch dot: the ring + shadow for white, else the shadow.
export const swatchBoxShadow = (color) =>
  isWhiteSwatch(color) ? `${WHITE_SWATCH_RING}, ${SWATCH_SHADOW}` : SWATCH_SHADOW;
